/** Eases from 56px to 24px as the conversation narrows, so a laptop keeps room for messages. */
export const THREAD_COLUMN_PADDING = "px-[clamp(1.5rem,6%,3.5rem)]"
